export class GradeLotNoRequest {
    lotNo: string;
    plantId: number;

    constructor(lotNo: string,plantId: number){
        this.lotNo = lotNo;
        this.plantId = plantId;
    }
}